import { render } from "./Container.vue?vue&type=template&id=6a108529&scoped=true"
const script = {}

import "./Container.vue?vue&type=style&index=0&id=6a108529&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a108529"]])

export default __exports__